/** @format */

export const TwitterLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M29.282 6.70074C28.2987 7.15387 27.2488 7.46061 26.1422 7.60178C27.2825 6.88494 28.1361 5.76069 28.5454 4.43679C27.4888 5.08164 26.3172 5.55221 25.0706 5.81363C24.2483 4.89332 23.1583 4.2828 21.9701 4.0769C20.7819 3.87101 19.5619 4.08127 18.4997 4.67504C17.4375 5.2688 16.5925 6.21281 16.0961 7.3604C15.5997 8.508 15.4796 9.79492 15.7545 11.0212C13.5819 10.9116 11.4557 10.3245 9.51457 9.29808C7.57343 8.27168 5.86089 6.82905 4.48855 5.06421C3.99837 5.93543 3.74269 6.92908 3.74859 7.93989C3.74859 9.92673 4.7152 11.673 6.18011 12.6996C5.31251 12.6709 4.46402 12.4259 3.70526 11.985V12.0547C3.70472 13.3749 4.14088 14.6547 4.93976 15.6769C5.73864 16.6991 6.85106 17.4009 8.08832 17.6632C7.28688 17.8879 6.44745 17.9219 5.63181 17.7625C5.98307 18.8987 6.66468 19.8919 7.58155 20.6036C8.49842 21.3153 9.60484 21.7101 10.7465 21.7327C8.45992 23.6107 5.5537 24.462 2.66699 24.0995C5.17312 25.7778 8.08717 26.6688 11.0631 26.6667C21.1225 26.6667 26.6172 17.9577 26.6172 10.4165C26.6172 10.1725 26.6172 9.92847 26.6005 9.68447C27.6671 8.88277 28.6004 7.87192 29.3337 6.72339L29.2803 6.70074H29.282Z"
                fill={color}
            />
        </svg>
    );
};
